
const company = "http://211.37.148.101:8080/smhomepage/board/";
export const IPinUSE = company;
